import { Typography } from 'fronton-react';
import React from 'react';
import { questionsAccordionStyles } from './styles';
import { questionsDb } from './questions-db';
import { AccordionItem } from './accordion-item/accordion-item';

export const QuestionsAccordion = () => (
	<div>
		<Typography variant="h2" data-qa="questions-title">
			Вопросы и ответы
		</Typography>
		<div className={questionsAccordionStyles}>
			{questionsDb.map(el => (
				<AccordionItem {...el} key={el.text} />
			))}
		</div>
	</div>
);
